export default function TrustSection() {
  return (
    <section id="seguranca" className="py-16 md:py-24 px-6 md:px-10 relative overflow-hidden">
      {/* Dark warm gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#3d2e1e] via-[#2e2216] to-[#1f1710]"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto">
        {/* Top section */}
        <div className="mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-accent-300/30 bg-accent-500/10 mb-6">
            <span className="text-xs font-medium text-accent-300 tracking-wide">/ CSSBuy Sheet</span>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 max-w-[620px] leading-tight mb-8">
            Por que Nossa CSSBuy Spreadsheet É Diferente?
          </h2>

          <div className="space-y-4 max-w-[620px]">
            <p className="text-base md:text-lg text-background-100/90 leading-relaxed">
              Nossa CSSBuy Spreadsheet é mantida diariamente por uma equipe dedicada que testa e verifica 
              cada produto antes de adicioná-lo à lista. Não trabalhamos com links automáticos — 
              cada item é selecionado manualmente.
            </p>
            <p className="text-sm md:text-base text-background-100/70 leading-relaxed">
              Utilizamos critérios rigorosos de qualidade: avaliação do vendedor, histórico de vendas, 
              fotos reais dos produtos e feedback da comunidade. Assim você compra com confiança, 
              sabendo que cada link foi validado.
            </p>
            <p className="text-sm text-background-100/55 leading-relaxed">
              Além disso, oferecemos guias completos em português para cada etapa do processo: 
              desde a busca do produto até o rastreamento do pedido internacional.
            </p>
          </div>
        </div>

        {/* Bottom split section */}
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Product image */}
          <div className="lg:w-[380px] flex-shrink-0">
            <div className="w-full aspect-square rounded-2xl overflow-hidden bg-background-100 border-4 border-background-100/10">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20elegant%20product%20photography%20of%20curated%20fashion%20collection%20shoes%20bag%20and%20premium%20accessories%20arranged%20on%20light%20cream%20surface%20clean%20composition%20soft%20natural%20lighting%20warm%20beige%20and%20taupe%20background%20editorial%20style%20high%20detail%20no%20text%20no%20logos%20luxury%20minimal%20aesthetic%20different%20angle%20artistic%20arrangement&width=800&height=800&seq=trust-product-img-v2-04&orientation=squarish"
                alt="CSSBuy Spreadsheet produtos selecionados"
                title="Produtos da CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Stats + CTA */}
          <div className="flex-1 text-center lg:text-left">
            <div className="font-heading text-6xl md:text-7xl lg:text-8xl font-bold text-background-50 mb-4">
              10.000+
            </div>
            <p className="text-sm md:text-base text-background-100/70 leading-relaxed max-w-[440px] mb-3">
              Mais de 10.000 usuários já consultaram nossa CSSBuy Spreadsheet. 
              Acesse agora e descubra os produtos mais procurados pela comunidade.
            </p>
            <p className="text-xs md:text-sm text-background-100/50 leading-relaxed max-w-[440px] mb-8">
              Nossa base de dados inclui produtos verificados em mais de 14 categorias diferentes, 
              com atualizações frequentes para garantir que você sempre encontre o que procura.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-7 py-3 text-sm font-semibold text-foreground-900 bg-background-50 rounded-full hover:bg-accent-400 hover:text-white transition-all whitespace-nowrap"
            >
              Explorar Agora
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}